import config from "config/config"

export enum Environment {
    local = "local",
    dev = "dev",
    test = "test",
    test2 = "test2",
    staging = "staging",
    prod = "prod",
}

function getCurrentEnvironment() {
    switch (config.environmentSuffix) {
        case "local":
            return Environment.local
        case "dev":
            return Environment.dev
        case "tst":
            return Environment.test
        case "tst2":
            return Environment.test2
        case "stg":
            return Environment.staging
        default:
            return Environment.prod
    }
}

const env = getCurrentEnvironment()
export default env
